export enum ImporterEventType {
  EnableImportButton = 'EnableImportButton',
  ShowBackButton = 'ShowBackButton',
  EnableContinueButton = 'EnableContinueButton',
  Complete = 'Complete',
  Loading = 'Loading',
}
